import { render, staticRenderFns } from "./PacsAnalyticsSettingsFrame.vue?vue&type=template&id=65ee6226"
import script from "./PacsAnalyticsSettingsFrame.vue?vue&type=script&lang=js"
export * from "./PacsAnalyticsSettingsFrame.vue?vue&type=script&lang=js"
import style0 from "./PacsAnalyticsSettingsFrame.vue?vue&type=style&index=0&id=65ee6226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports